import { render, staticRenderFns } from "./RadishTableMin.vue?vue&type=template&id=fa935e9c&"
import script from "./RadishTableMin.vue?vue&type=script&lang=js&"
export * from "./RadishTableMin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports